import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column base-initial-screen" }
const _hoisted_2 = { class: "d-flex base-initial-screen__notification-wrapper" }
const _hoisted_3 = { class: "base-initial-screen__notification px-0 px-md-6" }
const _hoisted_4 = { class: "base-initial-screen__title px-1" }
const _hoisted_5 = {
  class: "text-center mt-3 mt-sm-6",
  style: {"max-width":"var(--initial-screen-max-width, 30em)","margin":"auto"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1 1 auto"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_evonum_svg = _resolveComponent("evonum-svg")!
  const _directive_initial_focus = _resolveDirective("initial-focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "notification")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.heroImg.url)
        ? (_openBlock(), _createBlock(_component_evonum_svg, {
            key: 0,
            style: _normalizeStyle([{"margin":"auto"}, _ctx.imageStyle]),
            src: _ctx.heroImg.url,
            center: "",
            aspectWidth: 650,
            aspectHeight: 450,
            alt: ""
          }, null, 8, ["style", "src"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("h1", {
          tabindex: "-1",
          class: _normalizeClass(_ctx.headingClasses)
        }, [
          _createTextVNode(_toDisplayString(_ctx.heading), 1)
        ], 2)), [
          [_directive_initial_focus, !_ctx.noInitialFocus]
        ]),
        _createElementVNode("p", {
          class: _normalizeClass([_ctx.textClasses, "mt-4"])
        }, _toDisplayString(_ctx.text), 3)
      ])
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _hoisted_6
  ]))
}